import { Storage } from 'aws-amplify';
import * as api from '../_api';
import uuidv4 from 'uuid/v4';
import * as API from '@/modules/files/_api';

// @ts-ignore
export const create = async ({ dispatch }, one) => {
  try {
    await api.create(one);
    dispatch('snackbar/success', 'Presseeintrag wurde erstellt', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const read = async ({ commit, dispatch }) => {
  try {
    const all = await api.read();
    commit('setAll', all);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const readOne = async ({ commit, dispatch }, { id }) => {
  try {
    const one = await api.readOne(id);
    commit('setOne', one);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const update = async ({ dispatch }, one) => {
  try {
    await api.update(one);
    dispatch('snackbar/success', 'Änderungen wurden gespeichert', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const remove = async ({ dispatch }, { id }) => {
  try {
    await api.remove(id);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

// @ts-ignore
export const uploadImage = async ({ dispatch }, image) => {
  try {
    const newName = `${Math.random().toString(36).substr(2, 20)}${Math.random().toString(36).substr(2, 20)}`;
    await Storage.put(`press/full/${newName}.${image.name.split('.').pop()}`, image);
    return `/press/full/${newName}.${image.name.split('.').pop()}`;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};


// @ts-ignore
export const uploadFile = async ({dispatch}, file) => {
  try {
    const uuid = uuidv4();
    let filename = file.name.split('.');
    const ext = filename.pop();
    filename = filename.join('.');
    filename = `press/${uuid}/${stringToSlug(filename)}.${ext}`;
    await API.uploadFile(`files/${filename}`, file);
    return filename;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};


function stringToSlug(str: string) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  let i = 0;
  const l = from.length;
  for (; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}
